import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://kahrvoefxxpexxobnyvv.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImthaHJ2b2VmeHhwZXh4b2JueXZ2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI1ODE5ODYsImV4cCI6MjA2ODE1Nzk4Nn0.fbBlQ-cnNKI71JpEl_FP2xIEdk1eEH6PvoKK5vwLcjg';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Bucket específico para o módulo Flow
export const FLOW_BUCKET = 'flow-logos';


// Helper functions para o Flow
export const uploadFlowLogo = async (file, flowId) => {
  try {
    // Gerar nome único para o arquivo
    const fileExt = file.name.split('.').pop();
    const fileName = `${flowId}-${Date.now()}.${fileExt}`;
    const filePath = `logos/${fileName}`;

    // Upload do arquivo
    const { data, error } = await supabase.storage
      .from(FLOW_BUCKET)
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: true
      });

    if (error) throw error;

    // Retornar URL pública
    const { data: publicData } = supabase.storage
      .from(FLOW_BUCKET)
      .getPublicUrl(filePath);

    return publicData.publicUrl;
  } catch (error) {
    console.error('Erro no upload:', error);
    throw error;
  }
};

export const deleteFlowLogo = async (logoUrl) => {
  try {
    if (!logoUrl) return;

    // Extrair o path do arquivo da URL
    const urlParts = logoUrl.split('/');
    const filePath = urlParts.slice(-2).join('/'); // pega "logos/filename.ext"

    const { error } = await supabase.storage
      .from(FLOW_BUCKET)
      .remove([filePath]);

    if (error) throw error;
    return true;
  } catch (error) {
    console.error('Erro ao deletar:', error);
    throw error;
  }
};